import { c as _c } from "react/compiler-runtime";
import { useExpandedSearchStore } from "../ExpandedSearchStore";
export function useRecentSearches() {
  const $ = _c(2);
  const storeRecentSearches = useExpandedSearchStore(_temp);
  let t0;
  if ($[0] !== storeRecentSearches) {
    t0 = storeRecentSearches.map(_temp2).sort(_temp3);
    $[0] = storeRecentSearches;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const recentSearches = t0;
  return recentSearches;
}
function _temp3(a, b) {
  return b.timestamp - a.timestamp;
}
function _temp2(recentSearch) {
  return {
    ...recentSearch,
    id: recentSearch.timestamp.toString()
  };
}
function _temp(state) {
  return state.recentSearches;
}